export { default } from './banner-loader';
